// extracted by mini-css-extract-plugin
module.exports = {"ariaSkipLinksContainer":"ra-z"};